// extracted by mini-css-extract-plugin
export default {"header":"Accordion_header__Gz0PR","icon":"Accordion_icon__Gtbtg","body":"Accordion_body__3ilNU"};